import { alpha, chipClasses, Components, Theme } from '@mui/material'

export const MuiChip: Components<Theme>['MuiChip'] = {
  variants: [
    {
      props: { variant: 'filled', color: 'warning' },
      style: ({ theme }) => ({
        backgroundColor: alpha(theme.palette.warning.main, 0.1),
        border: `1px solid ${theme.palette.warning.main}`,
        color: theme.palette.warning.dark,
        '&:focus': {
          backgroundColor: alpha(theme.palette.warning.main, 0.1),
          border: `2px solid ${theme.palette.warning.main}`,
        },
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: alpha(theme.palette.warning.main, 0.5),
        },
        [`& .${chipClasses.deleteIcon} , & .${chipClasses.icon}`]: {
          color: theme.palette.warning.dark,
        },
      }),
    },
    {
      props: { variant: 'filled', color: 'error' },
      style: ({ theme }) => ({
        backgroundColor: alpha(theme.palette.error.main, 0.1),
        border: `1px solid ${theme.palette.error.main}`,
        color: theme.palette.error.dark,
        '&:focus': {
          backgroundColor: alpha(theme.palette.error.main, 0.1),
          border: `2px solid ${theme.palette.error.main}`,
        },
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: alpha(theme.palette.error.main, 0.5),
        },
        [`& .${chipClasses.deleteIcon} , & .${chipClasses.icon}`]: {
          color: theme.palette.error.dark,
        },
      }),
    },
    {
      props: { variant: 'filled', color: 'success' },
      style: ({ theme }) => ({
        backgroundColor: alpha(theme.palette.success.main, 0.1),
        border: `1px solid ${theme.palette.success.main}`,
        color: theme.palette.success.dark,
        '&:focus': {
          backgroundColor: alpha(theme.palette.success.main, 0.1),
          border: `2px solid ${theme.palette.success.main}`,
        },
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: alpha(theme.palette.success.main, 0.5),
        },
        [`& .${chipClasses.deleteIcon} , & .${chipClasses.icon}`]: {
          color: theme.palette.success.dark,
        },
      }),
    },
    {
      props: { variant: 'filled', color: 'default' },
      style: ({ theme }) => ({
        backgroundColor: alpha(theme.palette.grey[500], 0.1),
        border: `1px solid ${theme.palette.grey[500]}`,
        color: theme.palette.text.primary,
        '&:focus': {
          backgroundColor: alpha(theme.palette.grey[500], 0.1),
          border: `2px solid ${theme.palette.grey[500]}`,
        },
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: alpha(theme.palette.grey[500], 0.5),
        },
        [`& .${chipClasses.deleteIcon} , & .${chipClasses.icon}`]: {
          color: theme.palette.text.primary,
        },
      }),
    },
    {
      props: { variant: 'filled', color: 'info' },
      style: ({ theme }) => ({
        backgroundColor: alpha(theme.palette.info.main, 0.1),
        border: `1px solid ${theme.palette.info.main}`,
        color: theme.palette.info.dark,
        '&:focus': {
          backgroundColor: alpha(theme.palette.info.main, 0.1),
          border: `2px solid ${theme.palette.info.main}`,
        },
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: alpha(theme.palette.info.main, 0.5),
        },
        [`& .${chipClasses.deleteIcon} , & .${chipClasses.icon}`]: {
          color: theme.palette.info.dark,
        },
      }),
    },
  ],
}
